import React from 'react'
import { withRouteData, Head } from 'react-static'
import { Container, BlurbSection } from 'components'

// TODO -- Add Outline to get to content quickly
export default withRouteData(({
  values, processBlurb, story, hireMeTo, goodFit, badFit, haveAProject,
}) => (
  <Container maxWidth="medium" mb={5}>
    <Head>
      <title>Will Hoag - Work Together</title>
      <meta name="description" content="Details about what it would be like to work together on a project" />
    </Head>
    <BlurbSection mt={5} blurb={haveAProject} />
    <BlurbSection mt={5} blurb={hireMeTo} />
    <BlurbSection mt={5} blurb={story} />
    <BlurbSection mt={5} blurb={values} />
    <BlurbSection mt={5} blurb={processBlurb} />
    <BlurbSection mt={5} blurb={goodFit} />
    <BlurbSection mt={5} mb={5} blurb={badFit} />
  </Container>
))



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Working.js